import { httpGet, httpPost } from "./claimsInvoicingApi";

export const getHierarchy = async (): Promise<HierarchicalDto> => httpGet("/users/hierarchy");

export const getUserRole = async (crmId: number): Promise<string> => httpGet(`/users/role/${crmId}`);

export const logout = async (): Promise<void> => {
    await httpPost<void, Record<string, never>>("/users/logout", {});
};

export type HierarchicalDto = {
    companyName: string;
    crmId: number | null;
    billingCity: string;
    children: RelatedCompanyDto[] | null;
    parent?: RelatedCompanyDto | null;
};

export type RelatedCompanyDto = {
    companyName: string;
    crmId: number | null;
    parentCrmId: number | null;
    billingCity: string;
};
